export interface DanceSchoolUserRoleScopeInterface {
  id: string;
  scopeKey: string;
}
